import { SpuClassDirtyContext } from '@knowledge/knowledges/singleClass/dirtyContext';
import { useFormikContext } from 'formik';
import { useContext, useEffect, useMemo } from 'react';

export function FormDiscardGuard({ id, active = true }: { id: string; active?: boolean }) {
  const { dirty } = useFormikContext();
  const { registerDirty } = useContext(SpuClassDirtyContext);

  useEffect(() => {
    registerDirty(id, active && dirty);
    return () => registerDirty(id, false);
  }, [active, dirty, id, registerDirty]);

  return null;
}

export function useConfirmBeforeDiscard<TArgs extends unknown[]>(
  onDiscard: (...args: TArgs) => void,
) {
  const { isDirty, wrapDirtyConfirm } = useContext(SpuClassDirtyContext);

  return useMemo(
    () => (isDirty ? (wrapDirtyConfirm(onDiscard) as (...args: TArgs) => void) : onDiscard),
    [isDirty, onDiscard, wrapDirtyConfirm],
  );
}
